import { OrganisationType } from "../user/types";
import type { UpdateContractBody } from "@supply25/shared/tenderPackage/contractsApi";

export type ContractDate = string | null;

export enum TenderPackageStatus {
  DRAFT = "DRAFT",
  ACTIVE = "ACTIVE",
  CANCELLED = "CANCELLED",
  COMPLETE = "COMPLETE",
  REVIEW = "REVIEW",
  AWARDED = "AWARDED",
}

interface NewTenderPackage {
  name: string;
  contactName: string;
  contactEmail: string;
  description: string;
  allowImprovementPlan: boolean;
  submissionDeadline: ContractDate;
  createdDate: string;
  referenceId: string;
}

export type BasicInfoBodyRequest = Partial<NewTenderPackage>;

export interface TenderPackage extends NewTenderPackage {
  id: string;
  status: TenderPackageStatus;
  activatedDate?: string;
  suppliers?: Supplier[];
  contractId?: string;
}

interface ActiveTenderPackage extends NewTenderPackage {
  id: string;
  status: TenderPackageStatus;
  activatedDate?: string;
}

export type PublicGetTenderPackageById = Pick<
  ActiveTenderPackage,
  | "id"
  | "name"
  | "description"
  | "allowImprovementPlan"
  | "referenceId"
  | "status"
  | "submissionDeadline"
> & { organisationId: string; workspaceId: string; organisationName: string };

export type Supplier = {
  organisationId: string;
  workspaceId: string;
  name: string;
  organisationType: OrganisationType;
};

export type UpdateContract = Omit<UpdateContractBody, "contractId">;
